import LegalLayout, { LegalSection } from "@/components/site/LegalLayout";
import { BRAND } from "@/lib/brand";

export default function Privacy() {
  return (
    <LegalLayout
      title="Informativa sulla Privacy"
      kicker="Privacy Policy — Reg. UE 2016/679 (GDPR)"
      testId="privacy-page"
    >
      <p className="text-[16px] italic font-serif-display text-[#0A0A0A]">
        La Valle degli Iblei rispetta la tua privacy. Questa informativa
        descrive come trattiamo i dati personali raccolti tramite il sito{" "}
        <strong>www.lavalledegliiblei.it</strong>.
      </p>

      <LegalSection num="01" title="Titolare del Trattamento">
        <p>
          Il Titolare del trattamento dei dati è {BRAND.founder} — La Valle
          degli Iblei, Sicilia, Italia.
        </p>
        <p>
          Email di contatto:{" "}
          <a href={`mailto:${BRAND.email}`} className="underline">
            {BRAND.email}
          </a>
        </p>
        <div className="mt-6 p-5 bg-[#FDFBF7] border-l-2 border-[#C4A671]">
          <span className="overline text-[9.5px] text-[#C4A671] block mb-2">
            Conformità &amp; Modello Operativo
          </span>
          <p className="text-[14px] leading-[1.8] text-[#2C2C2C] font-light">
            <em className="font-serif-display text-[#0A0A0A]">
              La Valle degli Iblei
            </em>{" "}
            è un progetto di Brand Development, Marketing e Direzione
            Commerciale di {BRAND.founder}. Le attività fisiche di produzione,
            vinificazione, affinamento e imbottigliamento sono interamente
            delegate e realizzate presso cantine partner vinicole terze,
            autorizzate e in possesso di regolari licenze di legge,
            certificazioni DOC/IGT e abilitazioni sanitarie conformi alla
            normativa vigente nazionale ed europea in materia enologica. Il
            marchio opera secondo un modello operativo{" "}
            <em className="font-serif-display">"asset-light"</em> di selezione,
            curatela e valorizzazione commerciale delle referenze.
          </p>
          <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3 text-[12.5px] text-[#5C5C5C]">
            <span><strong className="text-[#0A0A0A]">Proprietà del Marchio e Direzione:</strong> Claudio Pucci</span>
            <span><strong className="text-[#0A0A0A]">Sede Operativa:</strong> Sicilia, Italia</span>
          </div>
        </div>
      </LegalSection>

      <LegalSection num="02" title="Dati Raccolti">
        <p>
          Raccogliamo esclusivamente i dati che fornisci volontariamente
          tramite il form di contatto:
        </p>
        <ul className="list-disc pl-6 space-y-2 marker:text-[#C4A671]">
          <li>Nome e cognome</li>
          <li>Nome dell'azienda o ristorante</li>
          <li>Indirizzo email</li>
          <li>Canale di interesse (Ho.Re.Ca. o Export)</li>
          <li>Contenuto del messaggio</li>
        </ul>
      </LegalSection>

      <LegalSection num="03" title="Finalità del Trattamento">
        <p>
          I tuoi dati sono trattati esclusivamente per:
        </p>
        <ul className="list-disc pl-6 space-y-2 marker:text-[#C4A671]">
          <li>Rispondere alla tua richiesta di informazioni commerciali</li>
          <li>Valutare allocazioni per il canale Ho.Re.Ca. e Export</li>
          <li>Eventuali comunicazioni di follow-up commerciale strettamente correlate</li>
        </ul>
        <p>
          Non utilizziamo i tuoi dati per finalità di marketing automatizzato
          né li condividiamo con terze parti per scopi promozionali.
        </p>
      </LegalSection>

      <LegalSection num="04" title="Base Giuridica">
        <p>
          Il trattamento si fonda sul tuo consenso esplicito (art. 6.1.a GDPR)
          espresso al momento dell'invio del form e sull'interesse legittimo
          a evadere la richiesta commerciale (art. 6.1.b GDPR).
        </p>
      </LegalSection>

      <LegalSection num="05" title="Conservazione dei Dati">
        <p>
          I dati sono conservati per il tempo strettamente necessario alla
          gestione della richiesta e, comunque, per un massimo di 24 mesi
          dall'ultimo contatto utile, salvo obblighi di legge superiori.
        </p>
      </LegalSection>

      <LegalSection num="06" title="Diritti dell'Interessato">
        <p>
          In qualsiasi momento puoi esercitare i diritti previsti dagli
          articoli 15-22 del GDPR:
        </p>
        <ul className="list-disc pl-6 space-y-2 marker:text-[#C4A671]">
          <li>Accesso, rettifica o cancellazione dei dati</li>
          <li>Limitazione o opposizione al trattamento</li>
          <li>Portabilità dei dati</li>
          <li>Revoca del consenso in qualsiasi momento</li>
          <li>Reclamo all'Autorità Garante per la Protezione dei Dati Personali</li>
        </ul>
        <p>
          Per esercitare i tuoi diritti, scrivi a{" "}
          <a href={`mailto:${BRAND.email}`} className="underline">
            {BRAND.email}
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection num="07" title="Sicurezza">
        <p>
          Adottiamo misure tecniche e organizzative adeguate per proteggere
          i tuoi dati: trasmissione cifrata HTTPS, accesso limitato, backup
          regolari del database.
        </p>
      </LegalSection>

      <LegalSection num="08" title="Modifiche all'Informativa">
        <p>
          Ci riserviamo il diritto di aggiornare questa informativa per
          riflettere modifiche normative o operative. La versione più recente
          sarà sempre disponibile a questa pagina.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
